import * as React from 'react';
import DataProvider from '../../services/DataProvider';
import {CourseType} from '../../services/CoursesService';
import { Table, Row, Col, Form, Collapse, Container } from 'react-bootstrap';
import Utils from '../../services/Utils';
import { Result, Question } from '../../services/Learning';
import { FaChevronRight, FaChevronDown} from 'react-icons/fa';

interface IQuestionItemProps {
  question: Question;
}

interface IQuestionItemState {
  answersCollapsed: boolean[];
}

class QuestionItem extends React.Component<IQuestionItemProps, IQuestionItemState> {
  constructor(props: IQuestionItemProps) {
      super(props);

      this.state = {
          answersCollapsed: this.props.question.answers.map(item => true)
      };
  }

  switchCollapsed = (index: number) => {
      this.state.answersCollapsed[index] = !this.state.answersCollapsed[index];
      this.forceUpdate();
  }

  render() {
        console.log(this.props.question.image);
        return (
          <Row>
              <Col md={12}>
                <Row>
                  <Col md={this.props.question.image ? 8 : 12}>
                      <div dangerouslySetInnerHTML={{__html: this.props.question.text || ''}}></div>
                  </Col>
                  {this.props.question.image ?
                      <Col md={4}>
                          <img style={{width: "50%"}} src={Utils.getFileUrl(this.props.question.image) || ''} />
                      </Col>
                  : null}
                  </Row>
              </Col>
              <Col md={{span: 11, offset: 1}}>
                      {this.props.question.answers.map((answer, index) =>
                          <div key={index}>
                              <div style={{cursor: "pointer", fontWeight: 'bold'}} onClick={() => this.switchCollapsed(index)}>
                                  {this.state.answersCollapsed[index] ? <FaChevronRight /> : <FaChevronDown />}
                                  &nbsp;Ответ {(this.props.question.answers.length > 1) ? index + 1 : ''} - {Utils.dateTimeToFullStr(answer.date)}
                              </div>
                              {!this.state.answersCollapsed[index] ? 
                                  <Row>
                                      <Col md={answer.image && answer.image.id > 0 ? 8 : 12}>
                                          <div dangerouslySetInnerHTML={{__html: (answer.text || '') + (answer.isOptional ? ' (произвольный ответ)' : '')}}></div>
                                      </Col>
                                      {answer.image && answer.image.id > 0 ?
                                          <Col md={4}>
                                              <img style={{width: "100%"}} src={Utils.getFileUrl(answer.image) || ''} />
                                          </Col>
                                      : null}                                        
                                  </Row>
                              : null}
                          </div>
                      )}                    
              </Col>
          </Row>
      );
  }
}











export interface IResultComponentProps {
  result: Result;
  learningHistory: Question[];
}

export interface IResultComponentState {
  questionCollapsed: boolean[];
}

interface FinalGroupMark {
  group: number,
  finalMark: number
}

export default class ResultComponent extends React.Component<IResultComponentProps, IResultComponentState> {
  constructor(props: IResultComponentProps) {
    super(props);

    this.state = {
      questionCollapsed: this.props.learningHistory.map(item => true)
    }
  }

  switchCollapsed = (index: number) => {
    this.state.questionCollapsed[index] = !this.state.questionCollapsed[index];
    this.forceUpdate();
  }

  public render() {
    const assignment = this.props.result.courseUserAssignemt;

    return (
      <Container style={{marginBottom: '1rem'}}>
        <Row>
          <Col md={12}>
            <h3>{assignment.course.name || ''}</h3>
            <h4>{Utils.concatStrings(assignment.user.firstName, assignment.user.lastName)}</h4>
            <p>Оценка: {Utils.numberToStr(this.props.result.courseUserAssignemt.assessment)}</p>
            <p>Категория оценки: {assignment.markCategory ? assignment.markCategory : 'не определена'}</p>
            <p>Курс пройден: { Utils.dateTimeToStr(assignment.courseCompletionDate)}</p>
            <h4>Маршрут прохождения</h4>
            <div className="scenario-result">
              {this.props.learningHistory.map((question, index) =>
                <div key={index}>
                  <div style={{cursor: 'pointer', fontWeight: 'bold'}} onClick={() => this.switchCollapsed(index)}>
                    {this.state.questionCollapsed[index] ? <FaChevronRight /> : <FaChevronDown />}
                    &nbsp;{question.title || ''} - {Utils.dateTimeToFullStr(question.date)}
                  </div>
                  {!this.state.questionCollapsed[index] ?
                    <Row>
                      <Col md={{span: 11, offset: 1}}>
                        <QuestionItem question={question} />
                      </Col>
                    </Row>                  
                : null }
              </div>)}
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}
